import { ActionTypes, ActionEx } from './ngrx-store.actions';

export const initialState: any = {};

export function RootReducer(state = initialState, action: ActionEx): any {

    if (action.type === ActionTypes.save.toString()) {
        state = { ...state, ...action.payload };
        return state;
    }
    if (action.type === ActionTypes.delete.toString()) {
        state = resetObject(state);
        delete state[action.payload];
        return state;
    }
    return state;
}

function resetObject(data: any) {
    let newObj: any = {};
    Object.keys(data).forEach(function (key) {
        newObj[key] = Object.assign({}, data[key]);
    });
    return newObj;
}
